import { FilterLoadMore } from "components/CustomFilterMenu";
import FilterMenu from "components/CustomFilterMenu/FilterMenu";
import { useGetSalesmen } from "hooks/order";
import { useGetCustomerLoadMore, useGetSellerLevels } from "hooks/seller";
import { useWarehouse } from "hooks/warehouse";
import { IS_USED_APP } from "pages/App/Agent/constants";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const FilterLevel = ({ onFilter, defaultValue }) => {
  const { sellerLevels = [] } = useGetSellerLevels();

  const handleFilter = (checkedList) => {
    onFilter && onFilter({ sellerLevelIDs: checkedList });
  };

  const convertedOptions = sellerLevels.map((item) => ({ label: item.name, value: item.id }));

  return <FilterMenu options={convertedOptions} type="checkbox" onFilter={handleFilter} defaultValue={defaultValue} />;
};

const FilterWarehouse = ({ onFilter, defaultValue }) => {
  const { warehouses = [] } = useWarehouse();

  const handleFilter = (checkedList) => {
    onFilter && onFilter({ exportedWarehouseIDs: checkedList });
  };

  const convertedOptions = warehouses.map((item) => ({ label: item.name, value: item.id }));

  return (
    <FilterMenu
      options={convertedOptions}
      type="checkbox"
      onFilter={handleFilter}
      defaultValue={defaultValue}
      searchable
    />
  );
};

const FilterStatus = ({ onFilter, defaultValue }) => {
  const { t } = useTranslation();
  const handleFilter = (checkedValue) => {
    onFilter && onFilter({ isActive: checkedValue });
  };

  const convertedOptions = [
    { value: true, label: t("seller.cooperation") },
    { value: false, label: t("seller.stopCooperation") },
  ];

  return <FilterMenu options={convertedOptions} type="radio" onFilter={handleFilter} defaultValue={defaultValue} />;
};

const FilterInvited = ({ onFilter, defaultValue }) => {
  const { t } = useTranslation();
  const handleFilter = (checkedValue) => {
    onFilter && onFilter({ inviteStatus: checkedValue });
  };

  const SELLER_INVITATION_STATUS = [
    { value: IS_USED_APP.USED, label: t("seller.usedApp") },
    { value: IS_USED_APP.INVITED, label: t("seller.invited") },
    { value: IS_USED_APP.UNINVITED, label: t("seller.uninvited") },
  ];

  return (
    <FilterMenu options={SELLER_INVITATION_STATUS} type="radio" onFilter={handleFilter} defaultValue={defaultValue} />
  );
};

const FilterSupplier = ({ onFilter, defaultValue }) => {
  const { t } = useTranslation();
  const handleFilter = (checkedValue) => {
    onFilter && onFilter({ isSupplier: checkedValue });
  };

  const convertedOptions = [
    { value: true, label: t("supplier.yes") },
    { value: false, label: t("supplier.no") },
  ];

  return <FilterMenu options={convertedOptions} type="radio" onFilter={handleFilter} defaultValue={defaultValue} />;
};

const FilterGroupCustomer = ({ onFilter, defaultValue }) => {
  const [params, setParams] = useState({
    filters: { query: undefined },
    pagination: {
      offset: 0,
      limit: 10,
    },
  });

  const { hasMoreData, loadMoreDataCustomers, options = [] } = useGetCustomerLoadMore(params);

  const handleSearch = (value) => {
    setParams({
      filters: { ...params.filters, query: value || undefined },
      pagination: { offset: 0, limit: 10 },
    });
  };

  const handleFilter = (checkedList) => {
    onFilter && onFilter({ sellerGroupIDs: checkedList });
  };

  return (
    <FilterLoadMore
      onFilter={handleFilter}
      data={options}
      onLoadMoreData={loadMoreDataCustomers}
      onSearchTextChange={handleSearch}
      hasMore={hasMoreData}
    />
  );
};

const FilterContract = ({ onFilter, defaultValue }) => {
  const handleFilter = (checkedValue) => {
    onFilter && onFilter({ sellerContractStatus: checkedValue || undefined });
  };

  const CONTRACT_STATUS = [
    { value: "NONE", label: "Chưa có" },
    { value: "REQUIRED", label: "Cần ký hợp đồng" },
    { value: "ACTIVE", label: "Có hiệu lực" },
    { value: "EXPIRED", label: "Hết hiệu lực" },
    { value: "DISABLED", label: "Bị vô hiệu" },
  ];

  return <FilterMenu options={CONTRACT_STATUS} type="radio" onFilter={handleFilter} defaultValue={defaultValue} />;
};
const FilterSalesman = ({ onFilter, defaultValue }) => {
  const [params, setParams] = useState({
    pagination: { offset: 0, limit: 10 },
    filters: { query: "" },
  });
  const { loading, data: salesmenOptions, loadMoreSalesmen, hasMoreData } = useGetSalesmen(params);

  const handleFilter = (checkedList) => {
    onFilter && onFilter({ saleID: checkedList[0] });
  };

  const handleSearch = (value) => {
    setParams({
      ...params,
      pagination: { offset: 0, limit: 10 },
      filters: { query: value },
    });
  };

  return (
    <FilterLoadMore
      onFilter={handleFilter}
      data={salesmenOptions}
      onLoadMoreData={loadMoreSalesmen}
      onSearchTextChange={handleSearch}
      hasMore={hasMoreData}
      loading={loading}
    />
  );
};
export {
  FilterContract,
  FilterGroupCustomer,
  FilterInvited,
  FilterLevel,
  FilterStatus,
  FilterSupplier,
  FilterWarehouse,
  FilterSalesman,
};
